"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAuctionBidBidderDto = instanceOfAuctionBidBidderDto;
exports.AuctionBidBidderDtoFromJSON = AuctionBidBidderDtoFromJSON;
exports.AuctionBidBidderDtoFromJSONTyped = AuctionBidBidderDtoFromJSONTyped;
exports.AuctionBidBidderDtoToJSON = AuctionBidBidderDtoToJSON;
exports.AuctionBidBidderDtoToJSONTyped = AuctionBidBidderDtoToJSONTyped;
/**
 * Check if a given object implements the AuctionBidBidderDto interface.
 */
function instanceOfAuctionBidBidderDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    return true;
}
function AuctionBidBidderDtoFromJSON(json) {
    return AuctionBidBidderDtoFromJSONTyped(json, false);
}
function AuctionBidBidderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'],
        'isVerified': json['isVerified'],
        'image': json['image'] == null ? undefined : json['image'],
    };
}
function AuctionBidBidderDtoToJSON(json) {
    return AuctionBidBidderDtoToJSONTyped(json, false);
}
function AuctionBidBidderDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'countryCode': value['countryCode'],
        'phone': value['phone'],
        'email': value['email'],
        'isVerified': value['isVerified'],
        'image': value['image'],
    };
}
